import { Component } from 'react';
import CommonTechnicalIssue from './common-technical-issue';
import DataLakeTracker from '../utils/tracking/data-lake-tracker';

class CommonErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error) {
    this.setState({ error });
  }
  render() {
    const { error } = this.state;
    if (error !== null) {
      DataLakeTracker({
        logEventType: 'error',
        eventName: `${error.name}: ${error.message}`,
        eventValue: error.stack,
        Authorization: null,
        customerId: null,
      });
    }
    if (error) {
      return (
        <>
          <CommonTechnicalIssue />
        </>
      );
    } else {
      return <>{this.props.children}</>;
    }
  }
}

export default CommonErrorBoundary;
